<template>
    <div class="popupBg" @click.self="pressDone">
        <div class="popupArea bg-lightest px-3">

            <div class="text-center fs-larger font-weight-600 p-3">
                Transport
            </div>

            <div class="text-center" v-if="!routes">
                <loader></loader>
            </div>

            <transport-editor :transfer="getSelectedReservation.transport.transfers[0]" :routes="routes" :reservation="getSelectedReservation" title="Pick up location" :type="1"></transport-editor>

            <div class="col-sm-12 my-2 text-right">
                <button class="btn primary wider ml-2"  @click="pressDone">Done</button>
            </div>


        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
import extendedVSelect from '@/extends/vue-select'

import TransportEditor from '@/components/reservations/NewReservation/Resume/AddTransport/RouteForm'
import Loader from '@/tools/loaders/loader1'

export default {
    data: function() {
        return {
            routes: null,
        }
    },
    created: function () {
        this.routes = this.getAllRoutes
    },
    props:{

    },
    computed: {
        ...mapGetters([
            'account',
            'getSelectedReservation',
            'getAllRoutes'
        ])
    },
    mixins:[
        reservationsMixin
    ],
    methods: {
        pressDone: function() {
            this.eventHub.$emit('editReservation_toggleEditTransport');
        },
    },
    components: {
        vSelect: extendedVSelect,
        TransportEditor,
        Loader
    }
}
</script>

<style lang="scss" scoped>

@import '../../../assets/scss/_variables.scss';

.paymentRowsHolder{
    // min-height: 100px;
    max-height: 200px;
    overflow: auto;

    div:nth-child(odd){
        background-color: $lighter;
    }
}

.payMethod{
    width: 103px;
    height: 72px;

    &.selected{
        border-color: $darkest !important;
        border-width: 2px !important;
    }

    &:hover{
        background-color: $lighter;
    }
}



.popupBg{
    background-color: rgba(0,0,0,0.5);
    width: 100%;
    height: 100%;
    z-index: 10;
    position: absolute;

    .popupArea{
        width: 800px;
        max-height: 100%;
        margin: 0 auto;
        overflow: auto;

    }
}



</style>



// WEBPACK FOOTER //
// EditTransport.vue?dbe5e140